module.exports = __webpack_public_path__ + "fonts/dd384a7fb76d904a987d1e3be0a8bd46.svg";